/** 概念来源：1 同花顺 concepts，2 开盘啦 kplConcepts，3 二者叠加去重 */
export const CONCEPT_SOURCE_THS = 1
export const CONCEPT_SOURCE_KPL = 2
export const CONCEPT_SOURCE_MERGE = 3

export const CONCEPT_SOURCE_OPTIONS = [
  { value: CONCEPT_SOURCE_THS, label: '同花顺' },
  { value: CONCEPT_SOURCE_KPL, label: '开盘啦' },
  { value: CONCEPT_SOURCE_MERGE, label: '叠加' }
]

export function resolveConceptsBySource(concepts, kplConcepts, source = CONCEPT_SOURCE_MERGE, localConcepts) {
  const ths = Array.isArray(concepts) ? concepts.map((c) => String(c || '').trim()).filter(Boolean) : []
  const kpl = Array.isArray(kplConcepts) ? kplConcepts.map((c) => String(c || '').trim()).filter(Boolean) : []
  const local = Array.isArray(localConcepts) ? localConcepts.map((c) => String(c || '').trim()).filter(Boolean) : []
  const base = source === CONCEPT_SOURCE_KPL ? kpl : source === CONCEPT_SOURCE_MERGE ? [...ths, ...kpl] : ths
  return [...new Set([...base, ...local])]
}
